import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FlightSpecialRequestsComponent } from './flight-special-requests.component';
import { PipesModule } from 'src/app/core/pipes/pipes.module';

@NgModule({
  declarations: [FlightSpecialRequestsComponent],
  imports: [CommonModule, SharedModule, PipesModule],
  exports: [FlightSpecialRequestsComponent]
})
export class FlightSpecialRequestsModule {}
